import React, { FC } from 'react';
import { t } from 'i18next';
import { useFormApi } from 'informed';
import { notEmptyValidator } from '@common/utils';
import { DateField } from '../../../../../legacyInputs';
import css from '../styles.module.scss';

interface IPickupDateField {
  multilegField?: string;
}

const PickupDateField: FC<IPickupDateField> = ({ multilegField }) => {
  const formApi = useFormApi();
  const fieldName = multilegField ? `${multilegField}.pickup_date` : 'pickup_date';

  return (
    <div className={css.field} data-testid="mobility-planner-edit-form-pick-up-date">
      <DateField
        className={css.input}
        dropdownMode="select"
        label={t('bookingDetails.pickupDate')}
        name={fieldName}
        showMonthDropdown
        showYearDropdown
        validate={notEmptyValidator}
        onChange={(value) => formApi.setValue('dropoff_date', value)}
      />
    </div>
  );
};

export default PickupDateField;
